import React from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";

import locations from './locations';


const useStyles = makeStyles(theme => ({
    dialogTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    dialogActions: {
        justifyContent: 'center'
    },
    dialogButton: {
        minWidth: 170,
        maxWidth: '100%'
    },
    cancelButton: {
        minWidth: 100,
    },
    form: {
        display: 'flex',
        width: 542,
        maxWidth: '100%',
        paddingBottom: 10,
        '& .MuiFormControl-root': {
            width: 540,
            maxWidth: '100%'
        },
    },
}));


const AddUserDialog = (props) => {
    const {
        open,
        handleClose,
        scroll,
        handleUserAdded
    } = props;

    const classes = useStyles();

    const clearedForm = {
        first_name: '',
        last_name: '',
        province_id: '',
        email: '',
        password: '',
        phone_number: '',
        is_officiant: true,
        is_admin: false,
        is_couple: true,
        is_limited_admin: false,
        can_add_couple: false,
        location: '',
    };

    const [showProgress, setShowProgress] = React.useState(false);

    /* form state */
    const [state, setState] = React.useState(clearedForm);
    const updateState = (value, name) => {
        const data = {
            ...state,
            [name]: value,
        };
        setState(data);
    }
    const handleChange = name => event => {
        let value = event.target.value;
        updateState(value, name);
    }

    const provinces = window.provinces;

    const submitForm = event => {
        event.preventDefault();

        const formData = {
            ...state,
            _token: window._token
        };
        new Promise((resolve, reject) => {
            const url = '/api/admin/users';
            setShowProgress(true);
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    resolve();
                    setTimeout(() => {
                        setState(clearedForm);
                        handleUserAdded();
                        handleClose();
                    }, 90);
                })
                .catch(reason => {
                    alert('Please try again');
                })
                .finally(() => {
                    setShowProgress(false);
                })
        });
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth='xl'
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>Add User</DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
                <form className={classes.form} onSubmit={submitForm} id="user-form">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField id="first-name" label="First Name" value={state.first_name || ''} onChange={handleChange('first_name')} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField id="last-name" label="Last Name" value={state.last_name || ''} onChange={handleChange('last_name')} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                id="province"
                                label="User Province"
                                value={state.province_id}
                                onChange={handleChange('province_id')}
                                SelectProps={{
                                    autoWidth: true
                                }}
                            >
                                {provinces.map(option => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.province_name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                id="location"
                                label="Location"
                                value={state.location || ''}
                                onChange={handleChange('location')}
                                SelectProps={{
                                    autoWidth: true
                                }}
                            >
                                {locations.map(option => (
                                    <MenuItem key={option.id} value={option.value}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField id="email" label="Email (Username)" value={state.email || ''} onChange={handleChange('email')} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField id="password" label="Password" value={state.password || ''} onChange={handleChange('password')} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField id="phone-number" label="Phone Number" value={state.phone_number || ''} onChange={handleChange('phone_number')} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                select
                                id="is-officiant"
                                label="Officiant"
                                value={state.is_officiant}
                                onChange={handleChange('is_officiant')}
                                SelectProps={{
                                    autoWidth: true
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                select
                                id="is-couple"
                                label="Couple"
                                value={state.is_couple}
                                onChange={handleChange('is_couple')}
                                SelectProps={{
                                    autoWidth: true
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                select
                                id="is-admin"
                                label="Admin"
                                value={state.is_admin}
                                onChange={handleChange('is_admin')}
                                SelectProps={{
                                    autoWidth: true
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                select
                                id="is-limited-admin"
                                label="Limited Admin"
                                value={state.is_limited_admin}
                                onChange={handleChange('is_limited_admin')}
                                SelectProps={{
                                    autoWidth: true
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                select
                                id="add-couples"
                                label="Add Couples"
                                value={state.can_add_couple}
                                onChange={handleChange('can_add_couple')}
                                SelectProps={{
                                    autoWidth: true
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button onClick={handleClose} variant="outlined" className={[classes.dialogButton, classes.cancelButton].join(', ')}>
                    Cancel
                </Button>
                <Box component="span">
                    <Button
                        disabled={!state.first_name || !state.last_name || !state.email || !state.password || showProgress}
                        variant="contained"
                        color="primary"
                        type="submit"
                        form="user-form"
                        className={classes.dialogButton}
                        endIcon={showProgress ? <CircularProgress size={20} /> : null}
                    >
                        Add User
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export default AddUserDialog;
